import { useModal } from "@/hooks/modals/useModal";
import type { FormInstance } from "antd";
import { useEffect } from "react";
import type { BlacklistApplyFormFields } from "../type";
import type { SupplierBlacklistItemDetail } from "@/types/apis";
import { getFileName } from "@/utils/file";

export function useInitFormFields(
  form: FormInstance<BlacklistApplyFormFields>,
  detail?: SupplierBlacklistItemDetail,
) {
  const { props, open } = useModal("SUPPLIER_BLACK_LIST");
  const { supplier } = props;

  useEffect(() => {
    if (!open) return;
    if (supplier) {
      form.setFieldsValue({
        supplierCode: supplier.supplierCode,
        supplierUserName: supplier.supplierName,
        supplierUsUserName: supplier.supplierUsName,
      });
    }

    if (detail) {
      form.setFieldsValue({
        supplierCode: detail.supplierCode,
        supplierUserName: detail.supplierUserName,
        supplierUsUserName: detail.supplierUsUserName,
        blacklistReason: detail.blacklistReason,
        removeBlacklistReason: detail.removeBlacklistReason,
        files: detail.srmSupplierFlowBusinessFiles.map((f) => ({
          uid: f.id.toString(),
          url: f.fileUrl,
          name: getFileName(f.fileUrl),
        })),
      });
    }
  }, [open, form, supplier, detail]);
}
